import React from "react";
import { useTranslate } from "@refinedev/core";
import { Modal } from "@shared/components";
import { BookMonthForm } from "../BookMonthForm";
import { EditBookMonthModalProps } from "./types";
import { useEditBookMonthModal } from "./controller";

export const EditBookMonthModal = React.memo(({ modalRef, onComplete }: EditBookMonthModalProps) => {
  const translate = useTranslate();
  const { methods, handleSubmit, isPending } = useEditBookMonthModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("v2/bookstore/book_month_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <BookMonthForm />
    </Modal>
  );
});

EditBookMonthModal.displayName = "EditBookMonthModal";
